<template>
    <v-layout row>
        <v-flex xs12 sm12>
            <v-card class="elevation-1 transparent">
                <v-toolbar class="transparent" flat height="37">
                    <v-btn dark icon title="Back to previous page" @click="$router.go(-1)">
                        <v-icon>arrow_back</v-icon>
                    </v-btn>
                    <v-spacer></v-spacer>
                    <help-link appId="attendance" pageId="overtime-page" color="white"></help-link>
                    <v-chip v-if="frozenPeriod" label small class="warning" dark title="This period is already Frozen. You will not be able to change this record.">Frozen</v-chip>
                    <v-chip v-if="closedPeriod" label small class="grey darken-2" dark title="This period is already Closed. You will not be able to change this record.">Closed</v-chip>
                    <v-btn v-if="hasAddRights" fab small title="Add Overtime" class="primary" @click="showOvertime" v-show="!disableConditions">
                        <v-icon>add</v-icon>
                    </v-btn>
                </v-toolbar>
            </v-card>
            <v-alert v-if="approved_timereport" :value="true" color="warning" icon="warning" outline style="margin:5px 0px 10px 0px;">
                The timesheet for this period has already been approved.
            </v-alert> 
            <v-card class="elevation-1 mt-5"> 
                <v-toolbar flat height="45px">
                    <span class="font-weight-bold">Overtime Requests</span>
                    <v-spacer></v-spacer>
                    <span class="font-weight-bold">{{cutOffPeriod}}</span>
                </v-toolbar>
                <v-data-table
                    :headers="isMobile?headers_all_mobile:headers"
                    :items="overtime_details"
                    :loading="loading"
                    :rows-per-page-items="rowsPerPageItems"
                    :pagination.sync="paginationSync"
                >
                    <v-progress-linear v-slot:progress color="primary" indeterminate></v-progress-linear>
                    <template v-slot:items="props">
                        <tr @click="viewDetails(props.item)" class="clickable" title="Click to view timesheet for this period">
                            <td>
                                <span v-if="isMobile">{{ props.item.transDate | moment("MMM DD") }}</span>
                                <span v-else>{{ props.item.transDate | moment("YYYY-MM-DD") }}</span>
                            </td>
                            <td v-if="!isMobile">{{ props.item.hoursStr }}</td>
                            <td>{{ props.item.chargeableHours }}</td>
                            <td v-if="!isMobile">{{ props.item.startTime | moment("hh:mm a") }} - {{ props.item.endTime | moment("hh:mm a") }}</td>
                            <td>
                                <div v-if="isMobile">
                                    <span v-if="props.item.offsetOrPay==1">Time Off in Lieu</span>
                                    <span v-else>Paid Overtime</span>
                                </div>
                                <div v-else>
                                    <span v-if="props.item.offsetOrPay==1">Time Off in Lieu (TOIL)</span>
                                    <span v-else>Payroll (Paid Overtime)</span>
                                </div>
                            </td>
                            <td>
                                <b :class="commonfn.getStatusColor(props.item.status)">{{commonfn.getStatusDescription(props.item.status)}}</b>
                            </td>
                        </tr>
                    </template>
                </v-data-table> 
            </v-card>
        </v-flex>

        <v-dialog v-model="dialogOvertime" width="600" persistent>   
            <overtime ref="overtimeRef" :showTransDatePicker="true" @send="getOvertime(false)" :dialogOvertime.sync="dialogOvertime"></overtime>
        </v-dialog>
    </v-layout>  
</template>

<script>

import overtimeApi from '@/api/overtime'
import commonfn from '@/common/functions'
import rowsPerPageItems from '@/constants/rows-per-page'
import { getSort, getRowsPerPage, updateRowsPerPage, updateSort } from '@/helpers/user-prefs'
import { hasAddRights } from '@/helpers/access-permissions'

export default {     
    name: 'MyOvertime',
    metaInfo: {
        title: 'My Overtime',
        meta: [
            { charset: 'utf-8' },
            { name: 'description', content: 'My Overtime' },
            { name: 'viewport', content: 'width=device-width, initial-scale=1' }
        ]
    },
    components: {
        'help-link': () => import('@/components/Common/HelpLink'),
        'overtime': () => import('@/components/Overtime/AddEditOvertime'),
    },   
    data () {
        const routeName = this.$route.name
        const savedSort = getSort(routeName)

        return {
            commonfn,
            rowsPerPageItems,
            error: false,
            errorMessage: '',
            loading: false,
            loading_download: false,
            serverDate: null,
            paginationSync: {
                rowsPerPage: getRowsPerPage(routeName),
                sortBy: savedSort.sortBy,
                descending: savedSort.descending,
            },
            headers: [
                {text: 'Date',align: 'left',value: 'transDate', width:'10%', sortable:true},
                {text: 'Hours',align: 'left',value: 'hoursStr', width:'10%',sortable:true},
                {text: 'Chargeable Hours',align: 'left',value: 'chargeableHours', width:'5%',sortable:true},
                {text: 'Duration',align: 'left',value: 'startTime', width:'10%',sortable:true},
                {text: 'Charging Type',align: 'left',value: 'offsetOrPay', width:'10%',sortable:true},
                {text: 'Status',align: 'left',value: 'status', width:'10%',sortable:true},
            ],
            headers_all_mobile: [
                {text: 'Date',align: 'left',value: 'transDate', width:'10%', sortable:true},
                {text: 'Charge',align: 'left',value: 'chargeableHours', width:'10%',sortable:true},
                {text: 'Type',align: 'left',value: 'offsetOrPay', width:'40%',sortable:true},
                {text: 'Status',align: 'left',value: 'status', width:'40%',sortable:true},
            ],
            cutoff_details: null,
            overtime_details: [],
            dialogOvertime: false,
            timeReport: null
        }
    },
    methods: {  
        showOvertime() {
            var data = {
                mode: 'Add',
                cutoff: this.cutoff_details
            }
            this.$refs.overtimeRef.setParams(data)
            this.dialogOvertime = true
        },
        async downloadToExcel() {
        },
        viewDetails(data) {
            this.$router.push(`/myattendance/overtime/details/${data.overtimeId}`)
        }, 
        async getOvertime(show_loading) {
            try {
                this.loading = show_loading
                const response = await overtimeApi.getByCutoffByUser(this.selectedCutOffId)
                if (response && response.status == 200) {
                    this.cutoff_details = response.data.cutoffItem
                    this.overtime_details = response.data.items
                    this.timeReport = response.data.timeReport
                }
                this.loading = false
            }catch(error){
                this.error = true
                this.errorMessage = error
            }
        },
    },
    created() {
        //update header titles
        this.$root.$emit('setHeaderTitles', {
            display: true,
            headerTitle: 'My Overtime',
            headerPageTitle: ''
        })

        this.getOvertime(true)
    },
    watch: {
        'paginationSync.rowsPerPage'(newVal) {
            updateRowsPerPage(this.$route.name, newVal)
        },
        'paginationSync.sortBy'(newVal) {
            updateSort(this.$route.name, newVal, this.paginationSync.descending)
        },
        'paginationSync.descending'(newVal) {
            updateSort(this.$route.name, this.paginationSync.sortBy, newVal)
        }
    },
    computed: {
        hasAddRights() {
            return hasAddRights(this.$router.currentRoute.path)
        },
        selectedCutOffId() {
            return this.$route.params.cutOffId
        },
        cutOffPeriod() {
            if (this.cutoff_details)
                return `${this.$moment(this.cutoff_details.cutoffStart).format('MMM DD, YYYY')} to ${this.$moment(this.cutoff_details.cutoffEnd).format('MMM DD, YYYY')}`
        },
        approved_timereport() {
            if (this.timeReport)
                return this.timeReport.status==commonfn.getStatusCode('Approved')
        },
        frozenPeriod() {
            if (this.cutoff_details) 
                return this.cutoff_details.status==commonfn.getStatusCode('Frozen')
        },
        closedPeriod() {
            if (this.cutoff_details) 
                return this.cutoff_details.status==commonfn.getStatusCode('Closed')
        },
        disableConditions() {
            return (this.loading||
                    this.frozenPeriod || 
                    this.closedPeriod ||
                    this.approved_timereport
                    )  
        },
    }
}
</script>